// extracted by mini-css-extract-plugin
export default {"infoPanel":"InfoPanel_infoPanel__TRxpa","label":"InfoPanel_label__FxehS"};